export default __webpack_public_path__ + "static/media/pop-dropdown.9bc13ca3.webp";